import React ,{useContext}from "react";
import AddAdminHotel from "./addAdminHotel";
import AdminHotelTable from "./AdminHotelTable";
import Pagination from "../../Pagination";
import AdminContext from "./AdminDashContext";
import { Link } from "react-router-dom";
// {hotelData,handelAdd,handleDelete,handleEdit,handleEditTable,HotelToEdit,setHotelToEdit,currentPage,hanldeChange,length,postsPerPage}
export default function AdminHotelsFunc(){
 const {allHotels,addAdminHotel,deleteAdminHotel,updateAdminHotel ,editHotel,hotelToEdit,setHotelToEdit, currentPage,postsPerPage,paginate,newHotelData}=useContext(AdminContext)
    // Value to determine whether pagination should be applied or not 
    const shouldPaginate=allHotels.length>4
    const displayedHotels=shouldPaginate?newHotelData:allHotels
    return (
        <div className=" mb-16"> 
            <h4 className="items-center font-bold">HOTELS</h4>            
            <Link to="/adminDash/communicate/hotel_owners">hotelOwners</Link>
            <AddAdminHotel onAdd={addAdminHotel} onEdit={updateAdminHotel} hotelToEdit={hotelToEdit} setHotelToEdit={setHotelToEdit}/>
            <AdminHotelTable onDelete={deleteAdminHotel} hotelData={displayedHotels} onEdit={editHotel} currentPage={currentPage} hanldeChange={paginate} length={allHotels.length} postsPerPage={postsPerPage}/>
           {shouldPaginate?<Pagination postsPerPage={postsPerPage} totalPosts={allHotels.length} currentPage={currentPage} paginate={paginate}/>:null}
        </div>
    )
}